import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'

function getParameterByName(name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

class Start extends Component {
  render() {
    const { classes, theme, location } = this.props
    return (
      //"/console/search/saved_searches/filter?name="+data["Search_Name"]+"&search_id="+data["Search_ID"]+"&count="+data["searchCount"]
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          You can filter through saved searches using any of the listed filters.
          Just tap one of the options below to get started.
        </Typography>
        <Button
          onClick={() => {
            this.props.changeRoute(
              `/console/search/saved_searches/filter/color_priority?name=${getParameterByName(
                'name'
              )}&search_id=${getParameterByName(
                'search_id'
              )}&count=${getParameterByName('count')}`
            )
          }}
          className={classes.button}
          raised
          color="primary"
        >
          Priority Codes
        </Button>
        <Button
          onClick={() => {
            this.props.changeRoute(
              `/console/search/saved_searches/filter/color_priority?name=${getParameterByName(
                'name'
              )}&search_id=${getParameterByName(
                'search_id'
              )}&count=${getParameterByName('count')}`
            )
          }}
          className={classes.button}
          raised
          color="primary"
        >
          Colour Notifications
        </Button>
        <Button
          onClick={() => {
            this.props.changeRoute(
              `/console/search/saved_searches/filter/life_style?name=${getParameterByName(
                'name'
              )}&search_id=${getParameterByName(
                'search_id'
              )}&count=${getParameterByName('count')}`
            )
          }}
          className={classes.button}
          raised
          color="primary"
        >
          Lifestyle Filters
        </Button>
        <Button
          onClick={() => {
            this.props.changeRoute(
              `/console/search/saved_searches/filter/profile_facts?name=${getParameterByName(
                'name'
              )}&search_id=${getParameterByName(
                'search_id'
              )}&count=${getParameterByName('count')}`
            )
          }}
          className={classes.button}
          raised
          color="primary"
        >
          Profile Facts
        </Button>
        <Button
          onClick={() => {
            this.props.changeRoute(
              `/console/search/saved_searches/filter/text_filter?name=${getParameterByName(
                'name'
              )}&search_id=${getParameterByName(
                'search_id'
              )}&count=${getParameterByName('count')}`
            )
          }}
          className={classes.button}
          raised
          color="primary"
        >
          Text Search
        </Button>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Start)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Filters/scenes/Start/index.js